import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/analytics';
import 'firebase/compat/database';

export const firebaseConfig = {
  apiKey: "AIzaSyBom7uiiOEFPhQ2KdHnXTi3_2-jw1pl0og",
  authDomain: "frontina-100-3.firebaseapp.com",
  databaseURL: "https://frontina-100-3-default-rtdb.firebaseio.com",
  projectId: "frontina-100-3",
  storageBucket: "frontina-100-3.appspot.com",
  messagingSenderId: "777115812153",
  appId: "1:777115812153:web:91e166674a8f76616468e8",
  measurementId: "G-Y7QK6XM16S"
};

const app = firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth(app);
export const analytics = firebase.analytics(app);
export const storage = firebase.storage(app);
export const db = firebase.firestore(app);

const rtdb = firebase.database(app);

const createRef = (parentRef: any, path: any = null): any => {
  try {
    const safePath = path === undefined || path === null ? '' : String(path || '');
    const baseRef = safePath ? parentRef.child(safePath) : parentRef;
    return {
      ref: baseRef,
      child: (childPath: any) => {
        try {
          return createRef(baseRef, childPath === undefined ? '' : String(childPath || ''));
        } catch (e) {
          console.error('Error in child:', e);
          return createRef(baseRef, '');
        }
      },
      get: () => baseRef.once('value'),
      update: (values: any) => baseRef.update(values),
      on: (event: any, callback: any) => baseRef.on(event, callback),
      off: (event: any, callback: any) => baseRef.off(event, callback),
      remove: () => baseRef.remove(),
      key: baseRef.key
    };
  } catch (e) {
    console.error('Error creating ref:', e);
    const fallbackRef = rtdb.ref();
    return {
      ref: fallbackRef,
      child: (childPath: any) => createRef(fallbackRef, childPath),
      get: () => fallbackRef.once('value'),
      update: (values: any) => fallbackRef.update(values),
      on: (event: any, callback: any) => fallbackRef.on(event, callback),
      off: (event: any, callback: any) => fallbackRef.off(event, callback),
      remove: () => fallbackRef.remove(),
      key: fallbackRef.key
    };
  }
};

export const rdb = {
  ref: (path?: any) => createRef(rtdb.ref(), path === undefined ? '' : String(path || '')),
  getDatabase: () => rtdb
};

if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  auth.useEmulator('http://localhost:9099');
  db.useEmulator('localhost', 8080);
  storage.useEmulator('localhost', 9199);
  rtdb.useEmulator('localhost', 9000);
}

export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const usersRef = db.collection("UsuariosData");

export default db;
